import React, { Component } from 'react';
import { StripeProvider } from 'react-stripe-elements';
import PropTypes from 'prop-types';
import StripeStoreCheckout from './components/StripeStoreCheckout';
import './StripeCard.scss';

class StripeCard extends Component {
  static propTypes = {
    onLoad: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
  }

  state = {}

  render() {
    const { onLoad, onSuccess, onError } = this.props;
    return (
      <div className="stripe-card-wrapper">
        <StripeProvider apiKey="pk_test_PYHGDFpQHqttuEu7fQORNkjo">
          <StripeStoreCheckout onLoad={onLoad} onSuccess={onSuccess} onError={onError} />
        </StripeProvider>
      </div>
    );
  }
}

export default StripeCard;



// WEBPACK FOOTER //
// ./src/components/StripeCard/StripeCard.js